import React, { Suspense } from 'react';

import { ConnectedRouter } from 'connected-react-router';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './App';
import './i18n';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import './index.css';
import * as serviceWorker from './serviceWorker';
import configureStore, { history } from './store';

const store = configureStore();

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Suspense fallback={null}>
                <App />
            </Suspense>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'),
);

serviceWorker.unregister();
